// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBox_container__1OPYv","searchWrapper":"SearchBox_searchWrapper__T_9_P","searchText":"SearchBox_searchText__AZdAD","totalResults":"SearchBox_totalResults__faVV8"};